var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-85.333 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gb_svg__a)",
    transform: "translate(80)scale(.94)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M-256 0H768.02v512.01H-256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-256 0v57.244l909.535 454.768H768.02V454.77L-141.515 0zM768.02 0v57.243L-141.515 512.01H-256v-57.243L653.535 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M170.675 0v512.01h170.67V0zM-256 170.67v170.67H768.02V170.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M-256 204.804v102.402H768.02V204.804zM204.81 0v512.01h102.4V0zM-256 512.01 85.34 341.34h76.324l-341.34 170.67zM-256 0 85.34 170.67H9.016L-256 38.164zm606.356 170.67L691.696 0h76.324L426.68 170.67zM768.02 512.01 426.68 341.34h76.324L768.02 473.848z"
  })))));
};
export default SvgGb;